module.exports = __webpack_public_path__ + "static/media/Reservation_Layout_RS.05d55157.docx";